import { SearchQuery, SearchResponse } from "interfaces/common";

export const THEME_MODE_TOKEN = "THEME_MODE";

const config = {
  defaultPath: "/dashboard/default",
  fontFamily: `'Public Sans', sans-serif`,
  i18n: "en",
  miniDrawer: false,
  container: true,
  mode: "light",
  presetColor: "default",
  themeDirection: "ltr",
};

export default config;
export const drawerWidth = "18%";
export const mobileDrawerWidth = 260;

export const twitterColor = "#1DA1F2";
export const facebookColor = "#3b5998";
export const linkedInColor = "#0e76a8";

export const SEARCH_QUERY_DEFAULT: SearchQuery = {
  perPage: 12,
  page: 1,
  orderBy: "createdAt",
  orderDirection: "asc",
};

export const SEARCH_RESPONSE_DEFAULT: SearchResponse = {
  data: [],
  pagination: {
    ...SEARCH_QUERY_DEFAULT,
    total: 0,
    totalPage: 0,
  },
};

export const ACCEPTED_FILE_CSV = ["text/csv"];
export const ACCEPTED_FILE_EXCEL_XLSX = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const ACCEPTED_FILE_IMAGE = "image/*";
export const ACCEPTED_FILE_PDF = ["application/pdf"];
export const ACCEPTED_FILE_DOC_DOCX = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const MAX_FILE_SIZE = 12582912;
